(function() {

  const check = document.querySelector('.archive-news');

  if( check ) {
    // ArchiveControler + config
    const news_controler = new ArchiveControler();
      news_controler.register_archive_container( document.getElementById('ArchiveNews') );

      news_controler.register_filter_select( document.getElementById('Filter_1') );

      news_controler.register_self_loading_classname('news__loading');
      news_controler.register_more_button_classname('button__more');
  }

})();

// (function() {

//   var more_button_class = 'more-button';
//   var simpleArchiveContainer = document.querySelector('.simple-archive-container');

//   if( !simpleArchiveContainer ) return;

//   var simpleArchiveControler = new SimpleArchiveControler();
//   simpleArchiveControler.register_archive_container( simpleArchiveContainer );
//   simpleArchiveControler.register_more_button_classname( more_button_class );

// })();